
/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { Component, ViewEncapsulation, OnInit, AfterViewChecked } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'zsd-survey',
  templateUrl: '../view/survey.component.html',
  styleUrls: ['../view/survey.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SurveyComponent implements AfterViewChecked, OnInit {
  pathUrl: string;
  showDetailPage: boolean;
  windowSize: number;
  viewAll = true;
  viewSurveyDetail = false;
  mobileView = false;

  constructor( private router: Router) {

  }
  ngAfterViewChecked() {
    this.windowSize = window.innerWidth;
    this.checkMobileView();
  }
  ngOnInit() {
    this.pathUrl = this.router.url;
    if (this.pathUrl.endsWith('/survey')) {
      this.showDetailPage = false;
    } else { this.showDetailPage = true; }
  }
  showList() {
    this.showDetailPage = false;
    this.router.navigate(['survey']);
  }
  checkMobileView() {
    if (this.windowSize < 993) {
      if (this.showDetailPage) {
        this.viewSurveyDetail = true;
      } else { this.viewSurveyDetail = false; }
    }
  }
}
